import Layout from '../../components/feature/Layout';
import ServiciosTerreno from '../home/components/ServiciosTerreno';
import SEO from '../../components/feature/SEO';

const asesoriaJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Asesoría en Terreno HSE',
  provider: {
    '@type': 'Organization',
    name: 'SafeLine Solutions',
    url: `${import.meta.env.VITE_SITE_URL ?? ''}`,
  },
  url: `${import.meta.env.VITE_SITE_URL ?? ''}/asesoria-terreno`,
  description: 'Servicio de asesoría HSE presencial en faenas y obras. Profesionales especializados que actúan en terreno para prevenir riesgos y fortalecer la seguridad operacional.',
  areaServed: {
    '@type': 'Place',
    name: 'Latinoamérica',
  },
  serviceType: 'Asesoría en Terreno y Seguridad Operacional',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${import.meta.env.VITE_SITE_URL ?? ''}/` },
      { '@type': 'ListItem', position: 2, name: 'Servicios', item: `${import.meta.env.VITE_SITE_URL ?? ''}/servicios` },
      { '@type': 'ListItem', position: 3, name: 'Asesoría en Terreno', item: `${import.meta.env.VITE_SITE_URL ?? ''}/asesoria-terreno` },
    ],
  },
};

export default function AsesoriaPage() {
  return (
    <Layout>
      <SEO
        title="Asesoría en Terreno HSE | SafeLine Solutions"
        description="Servicio de asesoría HSE presencial en faenas y obras. Profesionales especializados que actúan en terreno para prevenir riesgos y fortalecer la seguridad operacional en Latinoamérica."
        keywords="asesoría en terreno HSE, seguridad faenas, prevención riesgos obras, seguridad operacional"
        canonical="/asesoria-terreno"
        jsonLd={asesoriaJsonLd}
      />
      <div className="pt-20">
        <ServiciosTerreno />
      </div>
    </Layout>
  );
}
